module.exports = __webpack_public_path__ + "static/stone_golem-027392276e502a36a01cfa4b621089bd.jpg";